type MessagingProfile = {
  messaging_enabled?: boolean;
} | null | undefined;

export const isSessionMessagingEnabled = (
  currentUser?: MessagingProfile
): boolean => currentUser?.messaging_enabled !== false;

export const canReceiveMessages = (profile?: MessagingProfile): boolean =>
  profile?.messaging_enabled !== false;
